/**
 * @file The full-shape guard for an ArTable raw table id: the `AR_TABLE_COLLECTION_PREFIX`, then one
 * or more ASCII letters, digits and underscores, at most the BigQuery table-name length in total.
 * It is the identifier gate: `parseAnalyticsBindings` admits a bound table only through it, and
 * `analyticsRawTableId` re-checks a bound-set member with it, because the `ArRawTableId` template
 * type admits any prefixed string. The cloud_run outbox and reconciled-row readers use it too.
 */
import type { ArRawTableId } from './Analytics.Catalog.types';
import { AR_TABLE_COLLECTION_PREFIX } from './System.Artifacts.types';

const BIGQUERY_TABLE_NAME_MAX_LENGTH = 1024;

const AR_RAW_TABLE_ID = new RegExp(`^${AR_TABLE_COLLECTION_PREFIX}[A-Za-z0-9_]+$`);

export const isArRawTableId = (value: unknown): value is ArRawTableId =>
  typeof value === 'string' && value.length <= BIGQUERY_TABLE_NAME_MAX_LENGTH && AR_RAW_TABLE_ID.test(value);
